var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellentColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1623 147.445C114.878 147.445 147.885 114.438 147.885 73.7223C147.885 33.0066 114.878 0 74.1623 0C33.4466 0 0.440002 33.0066 0.440002 73.7223C0.440002 114.438 33.4466 147.445 74.1623 147.445Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1623 86.0111C59.3236 86.0111 49.4776 84.2827 37.3011 81.9154C34.5202 81.3789 29.1098 81.9154 29.1098 90.1068C29.1098 106.49 47.9294 126.968 74.1623 126.968C100.391 126.968 119.215 106.49 119.215 90.1068C119.215 81.9154 113.804 81.3748 111.023 81.9154C98.8469 84.2827 89.0009 86.0111 74.1623 86.0111Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3011 90.1055C37.3011 90.1055 49.5882 94.2011 74.1623 94.2011C98.7364 94.2011 111.023 90.1055 111.023 90.1055C111.023 90.1055 102.832 106.488 74.1623 106.488C45.4925 106.488 37.3011 90.1055 37.3011 90.1055Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5882 69.6268C55.2431 69.6268 59.8274 63.2089 59.8274 55.2919C59.8274 47.375 55.2431 40.957 49.5882 40.957C43.9332 40.957 39.349 47.375 39.349 55.2919C39.349 63.2089 43.9332 69.6268 49.5882 69.6268Z",
    fill: "#664500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7363 69.6268C104.391 69.6268 108.976 63.2089 108.976 55.2919C108.976 47.375 104.391 40.957 98.7363 40.957C93.0814 40.957 88.4971 47.375 88.4971 55.2919C88.4971 63.2089 93.0814 69.6268 98.7363 69.6268Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellentColor);
export default __webpack_public_path__ + "static/media/excellentColor.7dc6996c58f97b5766679656f87d4a7e.svg";
export { ForwardRef as ReactComponent };